import React from 'react';
import { IMainHeader } from './types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { Menu, MenuItem, Drawer, AppBar, Toolbar, ListItem,
  ListItemIcon, ListItemText, List, Typography, Divider,
  IconButton, Icon, Grid } from '@material-ui/core';
import {Menu as MenuIcon, ChevronLeft as ChevronLeftIcon,
    ChevronRight as ChevronRightIcon, AccountCircle } from '@material-ui/icons';
import VenueSelect from '../VenueSelect';
const NowBookItLogo = '/connect/images/NBI-icon.svg';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  hide: {
    display: 'none',
  },
  accountName:{
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(1),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    backgroundImage: `url(${NowBookItLogo})`,
    backgroundColor: '#3f51b5',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '50px 50px',
    backgroundPosition: '7px 7px',
    '& .MuiSvgIcon-root': {
      fill: 'white'
    },
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  offset: theme.mixins.toolbar
}));

const navs = [
  { key: '', displayName: 'Home', icon: 'home'  },
  { key: 'apikeys', displayName: 'Integrations', icon: 'account_tree' },
  { key: 'dashboard/report', displayName: 'Dashboard', icon: 'bar_chart' },
  { key: 'dashboard/guests', displayName: 'Guests', icon: 'person' },
  { key: 'throttle', displayName: 'Throttle', icon: 'speed' },
  { key: 'log', displayName: 'Log', icon: 'notes' }
];

const isTruthyFlag = (value: string | null) => value === 'true' || value === '1';

export default function MainHeader({ handleSomeClick, user, handleLogOut, handleVenueListDrawerOpen }: IMainHeader) {

  const theme = useTheme();
  const classes = useStyles();
  const [openSideBar, setOpenSideBar] = React.useState(true);
  const [openAccountPopup, setOpenAccountPopup] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>();
  const openConnectIntegrationOnly = isTruthyFlag(localStorage.getItem('openConnectIntegration'));
  const visibleNavs = openConnectIntegrationOnly
    ? navs.filter((item) => item.key === 'apikeys')
    : navs;

  const handleDrawerOpenSideBar = () => {
    setOpenSideBar(true);
  };

  const handleDrawerClose = () => {
    setOpenSideBar(false);
  };

  const handleAccountInfoMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenAccountPopup(true);
  }

  const handleAccountInfoMenuClose = () => {
    setAnchorEl(null);
    setOpenAccountPopup(false);
  }

  return (
    <>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: openSideBar,
        })}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerOpenSideBar}
            className={clsx(classes.menuButton, {
              [classes.hide]: openSideBar,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Dashboard
          </Typography>
          {user &&
              <Grid container justify="flex-start" alignItems="center">
                <Grid item xs={6}></Grid>
                <Grid item xs={3}>
                  <VenueSelect handleVenueListDrawerOpen={handleVenueListDrawerOpen}/>
                </Grid>
                <Grid item xs={3}>
                <Typography variant="inherit" className={classes.accountName}>{user.firstName} {user.surname}</Typography>
                  <IconButton
                    data-testid="account-info-button"
                    aria-label="account information"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleAccountInfoMenuOpen}
                    color="inherit"
                  >
                    <AccountCircle />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left'
                    }}
                    keepMounted
                    getContentAnchorEl={null}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left'
                    }}
                    open={openAccountPopup}
                    onClose={handleAccountInfoMenuClose}
                  >
                    <MenuItem onClick={() => {
                      handleLogOut();
                      handleAccountInfoMenuClose();
                    }}>Log Out</MenuItem>
                  </Menu>
                </Grid>
              </Grid>
          }
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: openSideBar,
          [classes.drawerClose]: !openSideBar,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: openSideBar,
            [classes.drawerClose]: !openSideBar,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
        <List>
          {visibleNavs.map((item) => (
            <ListItem button key={item.key} component={Link} to={"/" + item.key}>
              <ListItemIcon><Icon>{item.icon}</Icon></ListItemIcon>
              <ListItemText primary={item.displayName} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}
